'use client';

import { useGateValue } from '@statsig/react-bindings';
import { useCallback, useEffect, useRef } from 'react';

import isBrowser from '@/utils/isBrowser';

import { isRealAnalyticsReadyForPageView } from '../utils';

const usePageView = (pageName: string): void => {
  // TODO: Remove after OneTrust CM rollout - remove gate check and legacy refs
  const isOneTrustEnabled = useGateValue('onetrust_segment_consent_manager');
  const pageLoaded = useRef(false);
  const sent = useRef(false);

  // TODO: Remove after OneTrust CM rollout - remove hasLegacyCMProps
  const hasLegacyCMProps = pageName && !pageLoaded.current;
  const hasOneTrustCMProps = pageName && !sent.current;

  const pageViewed = useCallback(async () => {
    if (isBrowser()) {
      await window.ouraAnalytics.page(pageName);
    }
  }, [pageName]);

  // TODO: After OneTrust CM rollout - remove isOneTrustEnabled check only
  // OneTrust path: only when gate is true. Wait for real analytics then send once.
  useEffect(() => {
    if (!hasOneTrustCMProps || !isOneTrustEnabled) return;

    function checkAndSend() {
      if (sent.current) return;
      if (!isRealAnalyticsReadyForPageView(isOneTrustEnabled)) return;
      sent.current = true; // Set this immediately to prevent duplicate calls
      pageLoaded.current = true;
      clearInterval(intervalId);
      void pageViewed();
    }

    // Poll every 100ms until real analytics has loaded, then send once
    const intervalId = setInterval(checkAndSend, 100);
    checkAndSend();
    return () => clearInterval(intervalId);
  }, [hasOneTrustCMProps, isOneTrustEnabled, pageViewed]);

  // TODO: Remove after OneTrust CM rollout - delete this entire useEffect
  // handles page views on Component change/browser refresh only (if OneTrust is disabled)
  useEffect(() => {
    if (!isOneTrustEnabled && hasLegacyCMProps) {
      void pageViewed();
      pageLoaded.current = true;
    }
  }, [isOneTrustEnabled, hasLegacyCMProps, pageViewed]);
};

export default usePageView;
